import React, { useMemo } from 'react'
import cx from 'classnames'
import * as Icon from '@manychat/icons'

import { default as tints } from '../../../constants/tints.json'

import { BasicSelectOption, SelectAnchorProps } from './interfaces'

import cm from './Select.module.css'

export const SelectAnchor = <OptionType extends BasicSelectOption>({
  renderAnchor,
  selectedOption,
  placeholder,
  value,
}: SelectAnchorProps<OptionType>) => {
  const labelToDisplay = useMemo(() => {
    if (value && typeof value === 'object' && value.label) {
      return value.label
    }

    if (selectedOption && selectedOption.label) {
      return selectedOption.label
    }

    return placeholder
  }, [value, selectedOption, placeholder])

  if (renderAnchor) {
    return <>{renderAnchor(selectedOption)}</>
  }
  return (
    <>
      <span className={cx(cm.placeholder, { [cm.selectedOption]: value || selectedOption })}>
        {labelToDisplay}
      </span>
      <Icon.ChevronDown size={20} color={tints.neutral[2]} />
    </>
  )
}
